import Paragraph from './Paragraph.vue'
import Code from './Code.vue'

export default {
  'block-paragraph': Paragraph,
  'block-codes': Code
}
